import { render, staticRenderFns } from "./HomeOld.vue?vue&type=template&id=0b2cb330&"
import script from "./HomeOld.vue?vue&type=script&lang=js&"
export * from "./HomeOld.vue?vue&type=script&lang=js&"
import style0 from "./HomeOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports